import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csgoto(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# goto tutorial For Beginners</title>
 <meta name="description" content="C# goto tutorial for beginners.goto in C# is is used to transfer the program control from one location to another location. Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# goto,c# goto for,c sharp goto,c# goto for loop,goto in c#,c# foreach goto,c# foreach continue" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-goto" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">C# Goto</h1>
    <div className="first">
        <a href="/csharp-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-array">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">C# Goto keyword:</h2>
<p className="mt-4 para">the C# Goto keyword in Csharp programming is used to transfer the program control from one location to another location.</p>


<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">c# goto syntax:</Card.Header>
  <Card.Body>
    <Card.Text>
    |<br/>
|<br/>
table name:<br/>
|<br/>
|<br/>
|<br/>
Goto table name<br/>

    </Card.Text>
  </Card.Body>
  <Card.Footer>This is a goto syntax in c#</Card.Footer>
</Card>

<h2 className="headings">Php goto syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-3">|</span>
            {"\n"}
            <span className="qwerty-3">|</span>
            {"\n"}
            <span className="qwerty-4">table </span>
            <span className="qwerty-5">name</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-3">|</span>
            {"\n"}
            <span className="qwerty-3">|</span>
            {"\n"}
            <span className="qwerty-3">|</span>
            {"\n"}
            <span className="qwerty-6">Goto </span>
            <span className="qwerty-4">table </span>
            <span className="qwerty-5">name</span>
            {"\n"}{"\n"}
         
          </code>
        </pre>
      </div>  



<h2 className="headings">Q-Write a Program on c# goto Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">namespace </span>
            <span className="qwerty-4">goto</span>
            {"\n"}
            <span className="qwerty-4">&#123;</span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program</span>
            {"\n"}
            <span className="qwerty-4">&#123;</span>
              {"\n"}
              <span className="qwerty-6">static </span>
            <span className="qwerty-7">void </span>
            <span className="qwerty-4">Main</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">string</span>
            <span className="qwerty-1">[]</span>
            <span className="qwerty">args</span>
            <span className="qwerty-2">)</span>
              {"\n"}
              <span className="qwerty-4">&#123;</span>
              {"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-5">1</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-9">Message</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6">Console.</span>
            <span className="qwerty-7">WriteLine</span>
            <span className="qwerty-3">(</span>
            <span className="qwerty">a</span>
            <span className="qwerty-6">)</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty">a</span>
                <span className="qwerty-7">--</span>
              <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-2">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty">a</span>
            <span className="qwerty-4">&#62;</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-5">0</span>
            <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-5">goto </span>
              <span className="qwerty-9">Message</span>
              <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">1</span>
              {"\n"}
              <span className="qwerty-6">0</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      


<h2 className="headings">Q-Write a Program on C# goto by using if-else Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">namespace </span>
            <span className="qwerty-4">goto</span>
            {"\n"}
            <span className="qwerty-4"> &#123;</span>
            {"\n"}
            <span className="qwerty-2"> class </span>
            <span className="qwerty">Program</span>
            {"\n"}
            <span className="qwerty-4"> &#123;</span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-7">void </span>
            <span className="qwerty-4">Main</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">string</span>
            <span className="qwerty-1">[]</span>
            <span className="qwerty">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-4"> &#123;</span>
            {"\n"}
            <span className="qwerty-5"> int </span>
            <span className="qwerty-1">goals</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-7">WriteLine</span>
            <span className="qwerty-6"> (</span>
            <span className="qwerty">"</span>
            <span className="qwerty-2">Enter </span>
            <span className="qwerty-3">the </span>
            <span className="qwerty-1">goals</span>
            <span className="qwerty">"</span>
            <span className="qwerty-6">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1"> goals</span>
            <span className="qwerty-7"> = </span>
            <span className="qwerty-3">Convert.</span>
            <span className="qwerty">ToInt32</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-3">Console.</span>
            <span className="qwerty-7">ReadLine</span>
            <span className="qwerty">()</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-1">goals </span>
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-5">5</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-4"> goto </span>
            <span className="qwerty-9">sos</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> else</span>
            {"\n"}
            <span className="qwerty-4"> &#123;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-7">WriteLine</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty">"</span>
            <span className="qwerty-4">Har </span>
            <span className="qwerty-6">Har </span>
            <span className="qwerty-3">Madadev</span>
            <span className="qwerty">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-7">WriteLine</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty">"</span>
            <span className="qwerty-3">Khalsa</span>
            <span className="qwerty">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1"> // </span>
            <span className="qwerty-5">terminates program execution</span>
            {"\n"}
            <span className="qwerty-4"> &#125;</span>
            {"\n"}
            <span className="qwerty-9"> sos</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-7">WriteLine</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty">"</span>
            <span className="qwerty-4">Code </span>
            <span className="qwerty-3">Exampler</span>
            <span className="qwerty">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4"> &#125;</span>
            {"\n"}
            <span className="qwerty-4"> &#125;</span>
            {"\n"}
            <span className="qwerty-4"> &#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">Enter </span>
            <span className="qwerty-3">the </span>
            <span className="qwerty-1">goals</span>
            {"\n"}
            <span className="qwerty-6">4</span>
            {"\n"}{"\n"}
            <span className="qwerty-7">Answer-</span>
            {"\n"}{"\n"}
            <span className="qwerty-4">Har </span>
            <span className="qwerty-6">Har </span>
            <span className="qwerty-3">Madadev</span>
            {"\n"}
            <span className="qwerty-3">Khalsa</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<p className="mt-4 para">If you don't know about input in Csharp so check on <a href="https://www.codeexampler.com/csharp-input">C# input tutorial</a>.</p>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-array">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csgoto;
